import { lazy } from "react";

export const RegistrationManagement = lazy(() => import("./RegistrationManagement"));
export const RegistrationEditManagement = lazy(() => import("./RegistrationEditManagement"));